import { toast } from "react-toastify";

export const showSuccessToast = (message, opts = {}) => toast(message, { className: "positive", ...opts });
export const showErrorToast = (message, opts = {}) => toast(message, { className: "negative", ...opts });
